export const RIBBON_STRIP_COUNT = 35;
export const RIBBON_BASE_HEIGHT = 4.0;
export const RIBBON_BASE_THICKNESS = 4.0;
export const RIBBON_VERTICAL_SPREAD = 0.65;
export const RIBBON_IMAGE_START_IDX = 12;
export const RIBBON_IMAGE_ROWS = 10;
export const RIBBON_WIDTH = 220;

export const RIBBON_COLORS = [
  "#E6DDB5", // Muted Parchment
  "#DCCCA3", // Aged Tape
  "#E8DFC5", // Pale Beige
  "#D4C596", // Dull Yellow
  "#A63D3A", // Muted Brick Red (Accent)
  "#C8B88A", // Greyish Gold
];

export const RIBBON_FONTS = ["Inter, sans-serif", "system-ui, sans-serif"];

export const RIBBON_TEXTS = [
  "404 NOT FOUND",
  "PAGE NOT FOUND",
  "ERROR 404",
  "NOT FOUND",
  "404",
  "SYSTEM ERROR",
  "LOST IN SPACE",
  "NOT FOUND 404",
];

export const BACKSIDE_TEXT = "INSPIRED BY DAY JOB";
export const BACKSIDE_IMAGE_PATH = "/experiments/404-not-found/dayjob.png";

// Animation Constants
export const RIBBON_TEXT_SPEED_RANGE = 6.0;
export const RIBBON_TEXT_SPEED_MULTIPLIER = 0.05;

export const RIBBON_WAVE_SPEED_MIN = 0.01;
export const RIBBON_WAVE_SPEED_VARIANCE = 0.015;
export const RIBBON_WAVE_SPEED_IMAGE_SECTION = 0.015;
